import Swiper, { Pagination } from 'swiper';

// configure Swiper to use modules
Swiper.use([Pagination]);

// TODO Move me
function initHeroRotator(){
	let swiper = [];
	$('.js-hero-rotator').each(function(index, element){
		let $this = $(this);
		let autorotate:any = $this.data('autorotate');
		let autorotateDelay:any = $this.data('autorotateDelay');
		let sliderList = [];

		//setup each swiper instance
		let swiper:any = new Swiper(this,{
			// Optional parameters
			init: false,
			loop: true,
			autoplay: autorotate === 'True' ? { delay: autorotateDelay ? autorotateDelay : 5000 } : false,
			slidesPerView: 1,

			pagination: {
				el: '.swiper-pagination',
				// type: 'bullets',
				// clickable: true
			},
			navigation: {
				nextEl: '.hero-image__content-middle .swiper-button-next',
    			prevEl: '.hero-image__content-middle .swiper-button-prev',
			},

			on: {
				slideChange: function(swiper:any) {
					let video:any  =  swiper.slides[swiper.activeIndex].querySelector('video');
					function transitionToNextSlide(e) {
						swiper.slideNext();
					}

					if(video) {
						video.addEventListener('ended', transitionToNextSlide, false);
						video.pause();
						video.currentTime = 0;
						video.load();
					}
				}
			}
		});

		//push up the swiper data
		sliderList.push(swiper);

		swiper.on('init', function(){

		});

		swiper.init();
	});
}

export function init() {
	if($('.js-hero-rotator').length) {
		initHeroRotator();
	}
}
